// extracted by mini-css-extract-plugin
export var addViewLink = "_17-1";
export var availabilityIcon = "_17-16";
export var availabilitySelectionIcon = "_17-15";
export var backButton = "_17-2";
export var backIcon = "_17-z";
export var conversationCount = "_17-3";
export var dragHandle = "_17-5";
export var dropdown = "_17-e";
export var dropdownIcon = "_17-7";
export var dropdownOption = "_17-6";
export var dropdownTriangle = "_17-d";
export var expand = "_17-f";
export var folder = "_17-i";
export var folderItem = "_17-c";
export var icon = "_17-8";
export var iconRow = "_17-9";
export var image = "_17-a";
export var logo = "_17-b";
export var navContainer = "_17-h";
export var navigationFooter = "_17-g";
export var pageShell = "_17-0";
export var placeholderAvailable = "_17-11";
export var placeholderBox = "_17-14";
export var placeholderBusy = "_17-13";
export var placeholderUnavailable = "_17-12";
export var profile = "_17-k";
export var profileContainer = "_17-m";
export var profileDropdown = "_17-n";
export var profileImage = "_17-l";
export var profileMain = "_17-o";
export var profileSubtitle = "_17-q";
export var profileTitle = "_17-p";
export var reorderIcon = "_17-r";
export var sentLine = "_17-u";
export var settingsHeader = "_17-s";
export var sidenavTextColor = "_17-y";
export var spamLine = "_17-t";
export var subitemWithTag = "_17-4";
export var supportItems = "_17-j";
export var teamText = "_17-10";
export var viewLine = "_17-x";
export var viewLineButton = "_17-w";
export var viewLineButtons = "_17-v";